import {DataGrid, GridColDef} from "@material-ui/data-grid";
import {StatusDisplay} from "../../../sharedComponents/StatusIcon";
import React, {FC} from "react";
import {AdminsReloadButton} from "./AdminsReloadButton";
import {MoreVert} from "@material-ui/icons";
import {useHistory} from "react-router-dom";
import {FeAdmin} from "../redux/types";
import {getFullName} from "../../../utils";
import {IconButton} from "@material-ui/core";
import {tableLocalizations} from "../../../sharedComponents/tableLocalizations";
import {TableToolbar} from "../../../sharedComponents/TableToolbar";

const columns: GridColDef[] = [
    {
        field: 'id',
        hide: true
    },
    {
        field: 'menu',
        disableColumnMenu: true,
        editable: false,
        resizable: false,
        flex: 0.15,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        renderHeader: () => <AdminsReloadButton/>,
        renderCell: () => <IconButton><MoreVert/></IconButton>
    },
    {
        field: 'active',
        headerName: 'Status',
        editable: false,
        filterable: true,
        width: 150,
        type: "boolean",
        valueFormatter: (params) => params.value === true ? "Aktiv" : "Inaktiv",
        renderCell: ({value}) => (
            <div style={{display: 'flex', flex: 1}}>
                <StatusDisplay active={Boolean(value)}/>
            </div>
        )
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 240,
        renderCell: (params) => getFullName(params.row as FeAdmin)
    },
    {
        hide: true,
        field: 'salutation',
        headerName: 'Anrede',
        width: 122
    },
    {
        hide: true,
        field: 'firstName',
        headerName: 'First name',
        width: 150
    },
    {
        hide: true,
        field: 'lastName',
        headerName: 'Last name',
        width: 150
    },
    {
        field: 'email',
        headerName: 'Email',
        flex: 0.5
    }
]


export const AdminsTable: FC<{ admins: FeAdmin[], loading: boolean }> = ({admins, loading}) => {
    const history= useHistory();
    return (
        <div style={{height: 710, width: '100%'}}>
            <DataGrid
                localeText={tableLocalizations}
                components={{
                    Toolbar: TableToolbar
                }}
                onRowClick={(param) => history.push(`/admin/admins/admin/${param.id}`)}
                loading={loading}
                rows={admins}
                disableMultipleSelection={true}
                columns={columns}
                isCellEditable={() => false}
                pageSize={5}
                checkboxSelection={false}
                disableSelectionOnClick
            />
        </div>
    )
}
